import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DsmApsSignOffContextService {
  readonly isLoading = signal<boolean>(false);
  readonly reload = signal<boolean>(false);

  requestReload(): void {
    this.reload.set(true);
  }

  reset(): void {
    this.isLoading.set(false);
    this.reload.set(false);
  }
}
